module.exports = __webpack_public_path__ + "static/media/question-faq.61617284.svg";